import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Swal from 'sweetalert2';

const KenaikanKelas = ({ token }) => {
  const [kelasList, setKelasList] = useState([]);
  const [kelasAsal, setKelasAsal] = useState('');
  const [kelasTujuan, setKelasTujuan] = useState('');
  const [siswaList, setSiswaList] = useState([]);
  const [selectedSiswa, setSelectedSiswa] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    axios.get('https://sijapan.sman10fajarharapan.sch.id/api/kelas', { headers: { Authorization: `Bearer ${token}` } })
      .then(res => setKelasList(res.data))
      .catch(err => console.error("Gagal ambil kelas:", err));
  }, [token]);

  useEffect(() => {
    if (kelasAsal) {
      setLoading(true);
      axios.get(`https://sijapan.sman10fajarharapan.sch.id/api/siswa?kelas=${kelasAsal}`, { headers: { Authorization: `Bearer ${token}` } })
        .then(res => {
            setSiswaList(res.data);
            setSelectedSiswa([]);
        })
        .finally(() => setLoading(false));
    } else {
        setSiswaList([]);
    }
  }, [kelasAsal, token]);

  const handleCheckbox = (id) => {
    // JANGAN DI-PARSEINT DULU, BIARKAN APA ADANYA DARI DB
    if (selectedSiswa.includes(id)) {
        setSelectedSiswa(selectedSiswa.filter(item => item !== id));
    } else {
        setSelectedSiswa([...selectedSiswa, id]);
    }
  };

  const handleSelectAll = (e) => {
    if (e.target.checked) {
        // Ambil ID mentah-mentah dari database
        const allIds = siswaList.map(s => s.id);
        setSelectedSiswa(allIds);
    } else {
        setSelectedSiswa([]);
    }
  };

  const handleMove = async () => {
    if (!kelasTujuan) return Swal.fire('Error', 'Pilih kelas tujuan!', 'error');
    if (selectedSiswa.length === 0) return Swal.fire('Error', 'Pilih siswa!', 'error');
    if (kelasAsal === kelasTujuan) return Swal.fire('Error', 'Kelas asal & tujuan sama!', 'warning');

    // DEBUG: Cek di Console Browser (Tekan F12 -> Console)
    console.log("DATA YANG AKAN DIKIRIM:", {
        siswaIds: selectedSiswa,
        kelasBaru: kelasTujuan
    });

    const confirm = await Swal.fire({
        title: `Pindahkan ${selectedSiswa.length} Siswa?`,
        text: `Ke ${kelasTujuan}`,
        icon: 'question',
        showCancelButton: true,
        confirmButtonText: 'Ya, Gas!',
        confirmButtonColor: '#10b981'
    });

    if (confirm.isConfirmed) {
        try {
            const res = await axios.put('https://sijapan.sman10fajarharapan.sch.id/api/siswa/pindah-kelas', 
                { siswaIds: selectedSiswa, kelasBaru: kelasTujuan },
                { headers: { Authorization: `Bearer ${token}` } }
            );
            
            console.log("RESPON SERVER:", res.data);
            Swal.fire('Sukses', res.data.message, 'success');
            
            // Hapus siswa yang berhasil dipindah dari tabel
            const sisaSiswa = siswaList.filter(s => !selectedSiswa.includes(s.id));
            setSiswaList(sisaSiswa);
            setSelectedSiswa([]);

        } catch (err) {
            console.error("ERROR AXIOS:", err);
            // Tampilkan pesan error asli dari backend jika ada
            const msg = err.response?.data?.message || 'Terjadi kesalahan sistem';
            Swal.fire('Gagal', msg, 'error');
        }
    }
  };

  return (
    <div style={{ paddingBottom: '50px' }}>
      <h2 style={{ color: '#1e293b' }}>🚀 Kenaikan / Mutasi Kelas</h2>
      
      <div style={{ background: 'white', padding: '20px', borderRadius: '12px', marginBottom: '20px', display: 'flex', gap: '20px', alignItems: 'end', flexWrap: 'wrap' }}>
        <div style={{ flex: 1 }}>
            <label style={{ fontWeight: 'bold', fontSize: '12px' }}>DARI KELAS</label>
            <select value={kelasAsal} onChange={e => setKelasAsal(e.target.value)} style={{ width: '100%', padding: '10px' }}>
                <option value="">-- Pilih --</option>
                {kelasList.map(k => <option key={k.id} value={k.nama_kelas}>{k.nama_kelas}</option>)}
            </select>
        </div>
        <div style={{ fontSize: '24px' }}>➔</div>
        <div style={{ flex: 1 }}>
            <label style={{ fontWeight: 'bold', fontSize: '12px' }}>KE KELAS</label>
            <select value={kelasTujuan} onChange={e => setKelasTujuan(e.target.value)} style={{ width: '100%', padding: '10px' }}>
                <option value="">-- Pilih --</option>
                {kelasList.map(k => <option key={k.id} value={k.nama_kelas}>{k.nama_kelas}</option>)}
            </select>
        </div>
        <button onClick={handleMove} style={{ padding: '12px 25px', background: '#10b981', color: 'white', border: 'none', borderRadius: '8px', cursor: 'pointer' }}>🚀 Pindahkan</button>
      </div>

      <div style={{ background: 'white', borderRadius: '12px', overflow: 'hidden', border: '1px solid #e2e8f0' }}>
        <table style={{ margin: 0, width: '100%' }}>
            <thead style={{ background: '#f1f5f9' }}>
                <tr>
                    <th width="50" style={{ textAlign: 'center' }}><input type="checkbox" onChange={handleSelectAll} /></th>
                    <th style={{padding:'10px'}}>Nama Siswa</th>
                    <th style={{padding:'10px'}}>Kelas</th>
                </tr>
            </thead>
            <tbody>
                {siswaList.length === 0 ? <tr><td colSpan="3" style={{textAlign:'center', padding:'20px'}}>Pilih kelas asal dulu.</td></tr> : 
                siswaList.map(s => (
                    <tr key={s.id} style={{ background: selectedSiswa.includes(s.id) ? '#f0fdf4' : 'white' }}>
                        <td style={{ textAlign: 'center' }}><input type="checkbox" checked={selectedSiswa.includes(s.id)} onChange={() => handleCheckbox(s.id)} /></td>
                        <td style={{padding:'10px'}}>{s.nama}</td>
                        <td style={{padding:'10px'}}>{s.kelas}</td>
                    </tr>
                ))}
            </tbody>
        </table>
      </div>
    </div>
  );
};

export default KenaikanKelas;